<div class="editor-wrapper">

  <!-- Toolbar -->
  <div class="toolbar">
    <button mat-icon-button (click)="format('bold')"><mat-icon>format_bold</mat-icon></button>
    <button mat-icon-button (click)="format('italic')"><mat-icon>format_italic</mat-icon></button>
    <button mat-icon-button (click)="format('underline')"><mat-icon>format_underlined</mat-icon></button>
    <button mat-icon-button (click)="format('strikethrough')"><mat-icon>strikethrough_s</mat-icon></button>
    <button mat-icon-button (click)="format('createLink')"><mat-icon>link</mat-icon></button>
    <button mat-icon-button (click)="format('insertUnorderedList')"><mat-icon>format_list_bulleted</mat-icon></button>
    <button mat-icon-button (click)="format('insertOrderedList')"><mat-icon>format_list_numbered</mat-icon></button>
  </div>

  <!-- Editable Text Area -->
  <div
    class="textbox"
    contenteditable="true"
    #editor
    (input)="onInput(editor.innerHTML)">
  </div>

  <!-- Bottom Actions -->
  <div class="bottom-row">
    <button mat-icon-button (click)="fileInput.click()">
      <mat-icon>attach_file</mat-icon>
    </button>
    <input #fileInput type="file" hidden (change)="onAttach($event)" />

    <button mat-icon-button><mat-icon>sentiment_satisfied_alt</mat-icon></button>

    <button mat-icon-button (click)="clear(editor)">
      <mat-icon>delete</mat-icon>
    </button>

    <span class="spacer"></span>
  </div>
</div>
